import magnifiAPIInstance from "./apiInstance";

export const ingestionAPIs = {
  getIngestionData: ({ payload }) => magnifiAPIInstance.get(`/api/v3/ingestion/${payload.entityId}`),

  changeIngestionStatus: ({ payload, entityId }) =>
    magnifiAPIInstance.put(`/api/v3/ingestion/${entityId}/toggle`, payload),
};
